import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppStorageService } from './app-storage.service';
import { StorageKeys } from './storage-keys';

/**
 * Servicio para gestionar el estado reactivo de los mensajes de chat
 */
@Injectable({
  providedIn: 'root'
})
export class ChatMessagesService {
  // BehaviorSubject para el contador de mensajes no leídos
  private unreadMessagesSubject = new BehaviorSubject<number>(0);

  constructor(private storage: AppStorageService) {

    // Inicializar con valor del storage si existe
    const storedCount = Number(this.storage.get(StorageKeys.UNREAD_MESSAGES)) || 0;
    this.unreadMessagesSubject.next(storedCount);
  }

  /**
   * @description Obtiene el estado reactivo del contador de mensajes no leídos
   * @returns Observable con el número de mensajes no leídos
   */
  getUnreadMessages(): Observable<number> {
    return this.unreadMessagesSubject.asObservable();
  }

  /**
   * @description Obtiene el estado reactivo booleano de mensajes no leídos
   * @returns Observable con true si hay mensajes no leídos, false en caso contrario
   */
  getHaveUnreadMessages(): Observable<boolean> {
    return this.unreadMessagesSubject.asObservable().pipe(
      map(count => count > 0)
    );
  }

  /**
   * @description Actualiza el contador de mensajes no leídos
   * @param count Nuevo conteo de mensajes no leídos
   */
  updateUnreadMessages(count: number): void {

    this.storage.set(StorageKeys.UNREAD_MESSAGES, count.toString());
    this.unreadMessagesSubject.next(count);
  }

  /**
   * @description Obtiene el valor actual del contador sin suscribirse
   * @returns Número actual de mensajes no leídos
   */
  getCurrentCount(): number {
    return this.unreadMessagesSubject.value;
  }
}
